import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaBars } from 'react-icons/fa';
import logo from './assets/images/kkc-logo.png'; // Adjust the path as needed
import SignOutButton from './SignOutButton';
import { FEATURE_SECTIONS } from './features';
import './LeftPanel.css';

function LeftPanel({ isVisible, onToggle }) {
    const location = useLocation();
    const toggleLabel = isVisible ? 'Hide menu' : 'Show menu';

    return (
        <>
            <button
                type="button"
                className="collapse-button"
                onClick={onToggle}
                aria-label={toggleLabel}
                aria-expanded={isVisible}
                title={toggleLabel}
            >
                <FaBars />
            </button>
            <div className={`left-panel ${isVisible ? '' : 'collapsed'}`} aria-hidden={!isVisible}>
                <div className="logo-container">
                    <Link to="/">
                        <img src={logo} alt="Kyber Knight home" className="logo" />
                    </Link>
                </div>
                <nav>
                    {FEATURE_SECTIONS.map((section) => (
                        <React.Fragment key={section.title}>
                            <h2 className="panel-header">{section.title}</h2>
                            <ul>
                                {section.features.map(({ path, label }) => (
                                    <li key={path} className={location.pathname === path ? 'active' : ''}>
                                        <Link to={path}>{label}</Link>
                                    </li>
                                ))}
                            </ul>
                        </React.Fragment>
                    ))}
                </nav>
                <SignOutButton />
            </div>
        </>
    );
}

export default LeftPanel;
